import React, { useId } from "react";
import { Button, Spinner } from "react-bootstrap";
import "./security.css";

const PhoneIcon = () => (
  <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ef8860"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="6" y="2" width="12" height="20" rx="2" />
    <path d="M11 18h2" />
  </svg>
);

// Spec "What it refuses": no number on screen except its last 4, whatever reaches this prop.
const lastFour = (phoneMasked) => `•••• ${String(phoneMasked || "").replace(/\D/g, "").slice(-4)}`;

const CardBody = ({ status, phoneMasked, loading, error, onSetup, onVerify, onChange, onRemove, onRetry }) => {
  if (loading) {
    return <p><Spinner animation="border" size="sm" /> Loading text message settings...</p>;
  }
  if (error) {
    return <div><div className="alert alert-danger" role="alert">{error}</div><Button onClick={onRetry}>Retry</Button></div>;
  }
  if (status === "ACTIVE") {
    return (
      <>
        <p>Codes go to {lastFour(phoneMasked)}.</p>
        <div className="mfa-actions">
          <Button variant="outline-secondary" className="mfa-btn-quiet" type="button" onClick={onChange}>Change number</Button>
          <Button variant="outline-secondary" className="mfa-btn-quiet mfa-btn-danger" type="button" onClick={onRemove}>Remove</Button>
        </div>
      </>
    );
  }
  // A1 (decided 2026-10-29): an opted-in number that was never proven is verified once before it signs anyone in.
  if (status === "UNVERIFIED") {
    return (
      <>
        <p>Verify your number to sign in with it</p>
        <p>Number on file: {lastFour(phoneMasked)}</p>
        <div><Button type="button" className="text-white fw-bold" onClick={onVerify}>Verify number</Button></div>
      </>
    );
  }
  return (
    <>
      <p>Get a code by text message when you sign in.</p>
      <div><Button type="button" className="text-white fw-bold" onClick={onSetup}>Set up text message</Button></div>
    </>
  );
};

// The "Text message (SMS)" card on My Profile -> Security (docs/specs/sms-factor.md §5). Presentational: every
// button calls a prop; the flows arrive in later phases of docs/plans/sms-factor.md.
const SmsFactorCard = (props) => {
  const headingId = useId();
  const on = props.status === "ACTIVE";
  const known = !props.loading && !props.error;
  return (
    <section className="mfa-card" aria-labelledby={headingId}>
      <div className="mfa-card-head">
        <PhoneIcon />
        <h2 id={headingId}>Text message (SMS)</h2>
        {known && <span className={`mfa-pill${on ? " is-on" : ""}`}>{on ? "On" : "Off"}</span>}
      </div>
      <CardBody {...props} />
    </section>
  );
};

export default SmsFactorCard;
